import {
  DeliveryService,
  Rate,
  ReferenceActions,
  Seller,
  SET_DELIVERY_SERVICES,
  SET_REFERENCE_RATE_LIST,
  SET_SELLER_LIST,
} from './types';

export interface ReferenceState {
  deliveryServicesList: Array<DeliveryService>,
  deliveryServices: {[key: string]: DeliveryService},
  sellers: Array<Seller>,
  rateList: Rate[],
  rates: {[key: string]: Rate}
}

const initialState: ReferenceState = {
  deliveryServicesList: [],
  deliveryServices: {},
  sellers: [],
  rateList: [],
  rates: {},
};

function prepareDeliveryServices(rawDeliveryServices: Array<DeliveryService>): {[key: string]: DeliveryService} {
  const deliveryServices: {[key: string]: DeliveryService} = {};
  if (deliveryServices) {
    for (let i = 0; i < rawDeliveryServices.length; i++) {
      deliveryServices[rawDeliveryServices[i].key] = rawDeliveryServices[i];
    }
  }
  return deliveryServices;
}

const prepareRates = (rateList: Rate[]) => {
  const rates: {[key: string]: Rate} = {};

  rateList.forEach((rate) => {
    rates[rate.code] = rate;
  });
  return rates;
};

export default function (state = initialState, action: ReferenceActions): ReferenceState {
  switch (action.type) {
    case SET_DELIVERY_SERVICES:
      return { ...state, deliveryServicesList: action.deliveryServices, deliveryServices: prepareDeliveryServices(action.deliveryServices) };
    case SET_SELLER_LIST:
      return { ...state, sellers: action.sellers };
    case SET_REFERENCE_RATE_LIST:
      return { ...state, rateList: action.list, rates: prepareRates(action.list) };
    default: return state;
  }
}
